module.exports = __webpack_public_path__ + "static/images/logo-bbc.dbd7c14b857fd72459cf279d52af01db.png";